/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';

import {REQUEST_OPTIONS} from '../../app.constants';
import {ApiService} from '../api/api.service';
import {Headers} from '../utils/headers';

export enum TrackingSources {
  GENERAL = 'GENERAL',
  VARIABLE_ELEMENTS = 'VARIABLE_ELEMENTS',
}

@Injectable()
export class ChangeTrackingService {
  dataSource = {
    [TrackingSources.GENERAL]: '/ga/api/v1/empTrack',
    [TrackingSources.VARIABLE_ELEMENTS]: '/variable/api/v1/empTrack',
  };

  constructor(private api: ApiService) {}

  public getChangeTrackingData(
    contractId: number,
    queryParams: string,
    source: TrackingSources = TrackingSources.GENERAL
  ) {
    return this.api
      .get(this.dataSource[source] + `/${contractId}/?${queryParams}`, REQUEST_OPTIONS.OBSERVE.RESPONSE)
      .pipe(
        map((result: any) => ({
          data: result.status === 204 ? [] : result.body,
          total: parseInt(Headers.get(result.headers, 'X-Total-Count')),
        }))
      );
  }
}
